import { fromJS } from 'immutable';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { IntervenantManagementInterfaceAction } from 'containers/IntervenantManagement/typings';
import {
  REQUEST_SET_MAPPING_LAWYERS,
  REQUEST_SET_MAPPING_LAWYER,
} from 'containers/IntervenantManagement/constants';

const initialState = fromJS({
  mappingLawyerJurisdiction: [],
  mappingLawyer: [],
});

const IntervenantManagementReducer = (
  state = initialState,
  action: IntervenantManagementInterfaceAction,
) => {
  switch (action.type) {
    case REQUEST_SET_MAPPING_LAWYERS:
      return state.set('mappingLawyerJurisdiction', fromJS(action.payload));
    case REQUEST_SET_MAPPING_LAWYER:
      return state.set('mappingLawyer', fromJS(action.payload));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default IntervenantManagementReducer;
